import { c as _c } from "react/compiler-runtime";
import { VStack, Separator } from '@chakra-ui/react';
import { useEducationContext } from '@src/components/sco/Education/EducationContext';
import ContentIntro from '@src/components/sco/Education/Other/ContentIntro';
import { MeetTheHosts } from '@src/components/sco/Education/PodcastLanding/MeetTheHosts';
import { PodcastHero } from '@src/components/sco/Education/PodcastLanding/PodcastHero';
import { PodcastList } from '@src/components/sco/Education/PodcastLanding/PodcastList';
import { PodcastSubscribe } from '@src/components/sco/Education/PodcastLanding/PodcastSubscribe';
import { useBreakpointContext } from '@src/components/sco/utilities/BreakpointProvider';
import { useUniversalEffect } from '@src/hooks/useUniversalEffect';
import React from 'react';
type PodcastLandingProps = {};
export const PodcastLanding: React.FC<PodcastLandingProps> = props => {
  const $ = _c(14);
  const educationContext = useEducationContext();
  const {
    getBreakpointValue
  } = useBreakpointContext();
  let t0;
  if ($[0] !== educationContext) {
    t0 = () => {
      educationContext.setBreadcrumbs([{
        title: "Podcast",
        href: "/podcast"
      }]);
    };
    $[0] = educationContext;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  useUniversalEffect(t0, t1);
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <PodcastHero />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== getBreakpointValue) {
    t3 = getBreakpointValue([10]);
    $[4] = getBreakpointValue;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <ContentIntro title="Startup Therapy Podcast" description={"The \"No BS\" version of how startups are really built, taught by actual startup Founders\n            who have lived through all of it."} />;
    t5 = <MeetTheHosts />;
    t6 = <Separator width="full" />;
    t7 = <PodcastSubscribe title="Stream on your favorite platforms" />;
    t8 = <Separator width="full" />;
    t9 = <PodcastList excludeFirst={true} title="Past Episodes" />;
    $[6] = t4;
    $[7] = t5;
    $[8] = t6;
    $[9] = t7;
    $[10] = t8;
    $[11] = t9;
  } else {
    t4 = $[6];
    t5 = $[7];
    t6 = $[8];
    t7 = $[9];
    t8 = $[10];
    t9 = $[11];
  }
  let t10;
  if ($[12] !== t3) {
    t10 = <VStack align="center" gap={0} justify="center" width="full">{t2}<VStack align="center" gap={12} maxWidth="container.xl" padding={t3} width="full">{t4}{t5}{t6}{t7}{t8}{t9}</VStack></VStack>;
    $[12] = t3;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  return t10;
};